import { useState } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import { MessageCircleQuestion, CheckCircle2, Loader2 } from "lucide-react";

/** One-question feedback prompt: "What's the #1 process driving you crazy right now?" */
export const FeedbackPrompt = () => {
  const location = useLocation();
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    setBusy(true);
    try {
      await api.post("/feedback", { message, email, path: location.pathname });
      setDone(true);
    } catch { /* ignore */ } finally { setBusy(false); }
  };

  return (
    <section className="bg-secondary/60 border-y border-border" data-testid="feedback-prompt">
      <div className="max-w-[820px] mx-auto px-6 lg:px-8 py-12">
        <div className="flex items-center gap-2 text-primary">
          <MessageCircleQuestion className="w-5 h-5" />
          <span className="text-xs uppercase tracking-[0.2em] font-semibold">30-second question</span>
        </div>
        <h2 className="font-heading font-black text-2xl md:text-3xl tracking-tight mt-3">
          What's the #1 process driving you crazy right now?
        </h2>
        {done ? (
          <div className="mt-5 flex items-center gap-2 text-green-700 font-medium" data-testid="feedback-thanks">
            <CheckCircle2 className="w-5 h-5" /> Thank you — this genuinely shapes what we build next.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-5 space-y-3">
            <textarea value={message} onChange={(e) => setMessage(e.target.value)} rows={3}
              placeholder="e.g. Getting every advisor to write repair orders the same way…"
              data-testid="feedback-message"
              className="w-full border border-border bg-white px-4 py-3 text-base focus:outline-none focus:border-primary" />
            <div className="flex flex-col sm:flex-row gap-3">
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="Email (optional — if you'd like a reply)" data-testid="feedback-email"
                className="flex-1 border border-border bg-white px-4 py-3 text-sm focus:outline-none focus:border-primary" />
              <button type="submit" disabled={busy || !message.trim()} data-testid="feedback-submit"
                className="inline-flex items-center justify-center gap-2 bg-primary text-white px-6 py-3 font-semibold btn-lift disabled:opacity-50 whitespace-nowrap">
                {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send it"}
              </button>
            </div>
          </form>
        )}
      </div>
    </section>
  );
};
